module.exports = __webpack_public_path__ + "img/i-products-admin.608f2ca3.svg";